import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "Classic Interior Renovations LTD";
const BASE = "https://classic-interior-renovations.com";
const DEFAULT_DESC =
  "Edmonton-based renovation company specializing in kitchens, bathrooms, basements, full home remodeling and custom interior projects. Built for the way you live.";
const DEFAULT_IMG =
  "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function Seo({ title, description, path = "/", image, rating, areaServed }) {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} | Edmonton Home Renovations`;
  const desc = description || DEFAULT_DESC;
  const url = `${BASE}${path}`;
  const img = image || DEFAULT_IMG;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "GeneralContractor",
    name: SITE,
    image: img,
    url: BASE,
    telephone: "+1-780-340-1023",
    email: "classicinteriorrenovation@gmail.com",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Edmonton",
      addressRegion: "AB",
      addressCountry: "CA",
    },
    areaServed: areaServed || "Edmonton, Alberta",
    priceRange: "$$",
    description: DEFAULT_DESC,
  };

  const ratingValue = rating && rating.value ? parseFloat(rating.value) : null;
  const ratingCount = rating && rating.count ? parseInt(rating.count, 10) : null;
  if (ratingValue && ratingCount) {
    jsonLd.aggregateRating = {
      "@type": "AggregateRating",
      ratingValue: ratingValue,
      reviewCount: ratingCount,
      bestRating: 5,
      worstRating: 1,
    };
  }

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
